"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var translations = {
  accordion: {
    collapse: 'Collapse',
    collapseAll: 'Collapse All',
    expand: 'Expand',
    expandAll: 'Expand All'
  },
  alert: {
    closeAlert: 'Close Alert',
    close: 'Close'
  },
  avatar: {
    aria: {
      label: '{descriptor} avatar'
    }
  },
  breadcrumbs: {
    aria: {
      label: 'Breadcrumbs'
    }
  },
  button: {
    loading: 'Loading...'
  },
  combobox: {
    clearButtonLabel: 'Clear {label} value',
    loading: 'Loading...',
    noMatches: 'No Matches Found',
    noMatchesMessage: 'Try removing or editing some of your criteria or search for different words.'
  },
  calendar: {
    daysOfWeek: {
      0: 'Sun',
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri',
      6: 'Sat'
    },
    month: {
      1: 'January {year}',
      2: 'February {year}',
      3: 'March {year}',
      4: 'April {year}',
      5: 'May {year}',
      6: 'June {year}',
      7: 'July {year}',
      8: 'August {year}',
      9: 'September {year}',
      10: 'October {year}',
      11: 'November {year}',
      12: 'December {year}'
    },
    today: 'Today',
    viewNextMonth: 'View next month',
    viewPrevMonth: 'View previous month'
  },
  drawer: {
    closeBtnTooltip: 'Close',
    closeBtn: 'Close Drawer'
  },
  jumpTo: {
    menuLabel: 'Jump To',
    navLabel: 'Jump To:'
  },
  notification: {
    closeHint: 'Close'
  },
  notifications: {
    dismissAll: 'Dismiss All'
  },
  modal: {
    closeHint: 'Close'
  },
  pagination: {
    previous: 'Previous',
    next: 'Next',
    aria: {
      label: 'Pagination',
      previous: 'Go to previous page, page {page}',
      next: 'Go to next page, page {page}',
      goToPage: 'Go to page {page}',
      currentPage: 'Current page, page {page}'
    }
  },
  select: {
    clearButtonLabel: 'Clear {label} value'
  },
  selectDate: {
    clear: 'Clear',
    clearButtonLabel: 'Clear {label} value',
    monthAbbreviations: {
      1: 'Jan',
      2: 'Feb',
      3: 'Mar',
      4: 'Apr',
      5: 'May',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec'
    }
  },
  selectDateRange: {
    apply: 'Apply',
    cancel: 'Cancel'
  },
  selectMenu: {
    allSelected: 'All',
    noneSelected: 'All',
    selectedCount: '{count} Selected'
  },
  tagInput: {
    tagAriaLabel: 'Remove {tagName}',
    clearButton: 'Clear {inputLabel}'
  },
  table: {
    sortIcons: {
      aria: {
        ascending: 'sorted ascending',
        descending: 'sorted descending',
        unsorted: 'unsorted'
      }
    }
  },
  textArea: {
    countMessage: 'You have {remaining} characters left ({max} max).'
  },
  textField: {
    requiredMessage: 'Required'
  },
  toggleView: {
    aria: {
      label: 'Toggle View',
      element: 'View element {id}'
    }
  },
  passwordField: {
    showPassword: 'Show Password',
    hidePassword: 'Hide Password',
    password: 'Password'
  },
  searchInput: {
    clear: 'Clear',
    search: 'Search',
    clearSearch: 'Clear search'
  }
};
var _default = translations;
exports.default = _default;